





















import LazyHydrate from "vue-lazy-hydration";
import { useRoute, defineComponent, onMounted, useContext } from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import AppHeader from "~/components/AppHeader.vue";
import IconSprite from "~/components/General/IconSprite.vue";
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import TopBar from "~/components/TopBar/TopBar.vue";
import InsideNotice from "~/components/General/InsideNotice.vue";
import ComparePop from '~/modules/catalog/category/components/compare/ComparePop.vue';
import YSF from '@neysf/qiyu-web-sdk';
 

export default defineComponent({
  name: "DefaultLayout",

  components: {
    // ComparePop,
    LoadWhenVisible,
    LazyHydrate,
    AppHeader,
    IconSprite,
    TopBar,
    InsideNotice,
    AppFooter: () =>
      import(/* webpackPrefetch: true */ "~/components/AppFooter.vue"),
    // CartSidebar: () =>
    //   import(
    //     /* webpackPrefetch: true */ "~/modules/checkout/components/CartSidebar.vue"
    //   ),
    // WishlistSidebar: () =>
    //   import(
    //     /* webpackPrefetch: true */ "~/modules/wishlist/components/WishlistSidebar.vue"
    //   ),
    // LoginModal: () =>
    //   import(
    //     /* webpackPrefetch: true */ "~/modules/customer/components/LoginModal/LoginModal.vue"
    //   ),
    Notification: () =>
      import(/* webpackPrefetch: true */ "~/components/Notification.vue"),
  },

  setup() {
    const route = useRoute();
    const {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
    } = useUiState();
    const { $config, app } = useContext();
    const query = route.value.query;
    const isApp = query.isApp;
    onMounted(() => {
      if (!isApp) {
        YSF.init($config.qiyuAppKey, {
          subdomain: 1,
          language: app.i18n.locale === 'zh'? 'zh-cn' : 'en'
        }, '').then(ysf => {
        // ysf('open');
        }).catch(error => {
          console.log('sdk加载失败---', error);
        });
      }
    });
    return {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
      route,
      isApp
    };
  },
});
